// import { PublicClientApplication } from '@azure/msal-browser';

// const msalConfig = {
//     auth: {
//         clientId: 'a435fe3f-ae9c-46ce-be32-63750aef1f03', // Replace with your client ID
//         authority: 'https://login.microsoftonline.com/3354127b-82b7-42ad-a618-ad0588025d66', // Replace with your tenant ID
//         redirectUri: 'http://localhost:3000', // Make sure this matches your app's redirect URI
//     },
//     cache: {
//         cacheLocation: 'localStorage',
//         storeAuthStateInCookie: false,
//     }

// };

// export const msalInstance = new PublicClientApplication(msalConfig);

// src/authConfig.js
import urlconfig from './urlConfig';
const passkey='test'
const envConfig = urlconfig(passkey);
export const msalConfig = {
  auth: {
    clientId: "a435fe3f-ae9c-46ce-be32-63750aef1f03", // Replace with your Azure AD App Client ID
    authority:
      "https://login.microsoftonline.com/3354127b-82b7-42ad-a618-ad0588025d66", // Replace with your Tenant ID
    redirectUri: envConfig.authurl, // Adjust if running on a different port
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};
